import parse from "../parse";
import { CoursesClass } from "../../constants/classes";

export default async function getCourseByName(courseName) {
  const course = parse.Object.extend(CoursesClass);
  const query = new parse.Query(course);
  query.equalTo("name", courseName);
  return await query.find();
}
